export const firebaseConfig = 
  process.env.NODE_ENV === 'production' ?
    {
      apiKey: "AIzaSyB88XNqE-9GSoLSxxTK3g15YTuB6QMnHJg",
      authDomain: "hr-board-prod.firebaseapp.com",
      databaseURL: "https://hr-board-prod.firebaseio.com",
      projectId: "hr-board-prod",
      storageBucket: "hr-board-prod.appspot.com",
      messagingSenderId: "254479623299"
    }
  :
    {
      apiKey: "AIzaSyBuawF2YvQ8u-TDFcxUTpg2PKkSc4fK3d4",
      authDomain: "hr-test-15e3c.firebaseapp.com",
      databaseURL: "https://hr-test-15e3c.firebaseio.com",
      projectId: "hr-test-15e3c",
      storageBucket: "hr-test-15e3c.appspot.com",
      messagingSenderId: "560943308449"
    }


// WEBPACK FOOTER //
// ./src/firebase/config.js